import { FeedItemValues } from './feed-item-values';

export class FeedItem {
    Id: number;
    Values: string;

    order: number;
    parsedValues: FeedItemValues;
}